import { render, staticRenderFns } from "./EditionModule.vue?vue&type=template&id=4aba8470&scoped=true&"
import script from "./EditionModule.vue?vue&type=script&lang=js&"
export * from "./EditionModule.vue?vue&type=script&lang=js&"
import style0 from "./EditionModule.vue?vue&type=style&index=0&id=4aba8470&lang=scss&scoped=true&"
import style1 from "./EditionModule.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aba8470",
  null
  
)

export default component.exports